"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Icon_1 = require("@ant-design/icons/lib/components/Icon");
var SvgCalendarFilledSvg = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { fillRule: "evenodd", d: "M4.8 1.6a.8.8 0 0 0-.8.8v.8h-.8a1.6 1.6 0 0 0-1.6 1.6v8a1.6 1.6 0 0 0 1.6 1.6h9.6a1.6 1.6 0 0 0 1.6-1.6v-8a1.6 1.6 0 0 0-1.6-1.6H12v-.8a.8.8 0 0 0-1.6 0v.8H5.6v-.8a.8.8 0 0 0-.8-.8m0 4a.8.8 0 1 0 0 1.6h6.4a.8.8 0 0 0 0-1.6z", clipRule: "evenodd" }))); };
var SvgCalendarFilled = function (props) { return (React.createElement(Icon_1.default, __assign({ component: SvgCalendarFilledSvg }, props))); };
exports.default = SvgCalendarFilled;
